import * as React from 'react';
import * as Images from 'pos/Images';
import { PreparationOrderDTO, Permission, Res, TicketLineDTO, TicketLineStatus } from 'core/api';
import { BackActionButton, Content, Footer, Header, PhoneOnly, PosScreen } from 'pos/ui';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { RestaurantFacade } from 'pos/facades';
import * as SalesStore from '../SalesStore';
import { Message, Modal } from 'core/ui-next/modal';
import { Box, VStack, Text } from '@chakra-ui/react';
import { CustomList, SvgIcon } from 'core/ui-next';

type Props = {
	currentPreparationOrderId: number,
	preparationOrders: PreparationOrderDTO[]
} & Modal.Actions<PreparationOrderDTO>;

function SetLinePreparationOrderScreen(props: Props) {
	const { preparationOrders, currentPreparationOrderId, close, cancel } = props;
	const onSelectOrder = (order: PreparationOrderDTO) => close(order);

	return <PosScreen screenId='SET_LINE_PREPARATION_ORDER' size='small' useKeyPad={false}>
		<Header title={Res.Web.SET_LINE_PREPARATION_ORDER()} onClose={cancel} />
		<Content>
			<VStack paddingX={'6'} paddingY={'9'} h='full' w='full' gap={'6'}>
				<VStack gap={'4'} justifyItems={'center'} w='full'>
					<SvgIcon src={Images.SetTicketLinePreparationOrder} w={'12'} h={'12'} />
					<Text fontSize={'md'} fontWeight={'bold'}>
						{Res.Web.SELECT_PREPARATION_ORDER_LBL()}
					</Text>
				</VStack>
				<Box w='full' overflowY={'auto'}>
					<CustomList
						items={preparationOrders}
						itemKey={order => order.Id}
						itemText={order => order.Name}
						onSelectItem={onSelectOrder}
						selectedItemKey={currentPreparationOrderId}
					/>
				</Box>
			</VStack>
		</Content>
		<Footer>
			<PhoneOnly>
				<BackActionButton action={async () => { cancel(); }} />
			</PhoneOnly>
		</Footer>
	</PosScreen>;
}

declare global {
	interface CommandType {
		setLinePreparationOrder: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('setLinePreparationOrder', Preconditions.ensure(Permission.Ticket_SetTicketLinePreparationOrder), async (line: TicketLineDTO): Promise<Result> => {

	if (line.Status !== TicketLineStatus.New) {
		await Message.show(Res.Msg.MSG_LINE_CANNOT_CHANGE_PREPARATION_ORDER());
		return Result.error();
	}

	if (!(line.Product && line.Product.PreparationTypeId)) {
		await Message.show(Res.Msg.MSG_CANNOT_CHANGE_PREPARATION_ORDER_FOR_A_PRODUCT_WITHOUT_PREPARATION_TYPE());
		return Result.error();
	}

	const preparationOrders = await RestaurantFacade.getPreparationOrders();
	const selectedPreparationOrderResult = await Modal.show(SetLinePreparationOrderScreen, { currentPreparationOrderId: line.PreparationOrderId, preparationOrders });

	if (!selectedPreparationOrderResult.ok)
		return Result.error();

	const selectedPreparationOrderValue = selectedPreparationOrderResult.value;
	await SalesStore.setLinePreparationOrder(line, selectedPreparationOrderValue);

	return Result.ok();
});
